// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		suggestionPosition: 'left',
		suggestionMobileStyle: 'style2',
	}
};

(function () {  // Add this

	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
        if (jQ('form.search.search__form').length > 0) jQ('form.search.search__form').off('submit');
      
		if (jQ(searchBoxId).closest('.search_container').length > 0) {
			this.setSuggestionWidth(searchBoxId, 400);
		}
	};
  
    var instantSearchInit = InstantSearch.prototype.init;

    InstantSearch.prototype.init = function() {  
      jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
        if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
          var clone = jQ(this).clone();
          jQ(this).replaceWith(clone);
        }
      });

      instantSearchInit.call(this);
    }  
})();  // Add this at the end